<img
  alt="RateMyAgent"
  [loaderParams]="{ type: 'staticImage' }"
  ngSrc="logos/logo-light.svg"
  width="156"
  height="46"
  disableOptimizedSrcset
/>

<nav class="flex max-w-[152px] justify-between">
  @for (social of socialLinks; track social.href) {
    <a
      rma-icon-button
      class="transition-color text-steel-40 text-small hover:!text-white"
      [attr.aria-label]="social.label"
      [href]="social.href"
      target="_blank"
      rel="noopener"
    >
      <rma-icon [glyph]="social.icon" />
    </a>
  }
</nav>

@if (details) {
  <dl *transloco="let t; prefix: 'footer'" class="text-bold text-steel-40">
    @if (details.salesNumber; as salesNumber) {
      <dt>{{ t('contact.sales') }}</dt>
      <dd class="mb-2">{{ salesNumber }}</dd>
    }
    @if (details.trainingWebinarUrl; as trainingWebinarUrl) {
      <dt>{{ t('contact.webinar.label') }}</dt>
      <dd class="mb-2">
        <a [href]="trainingWebinarUrl" target="_blank" rel="noopener">{{ t('contact.webinar.link') }}</a>
      </dd>
    }
    @if (details.intercom) {
      <dt>{{ t('contact.intercom.label') }}</dt>
      <dd>
        <button type="button" (click)="openIntercom()">{{ t('contact.intercom.link') }}</button>
      </dd>
    }
  </dl>
}
